import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "state/hooks";

const PrivateRoute = () => {
  const location = useLocation();
  const { token } = useAppSelector((state) => state.userInfo);

  if (!token && location.pathname !== "/dashboard/sign-in") {
    return <Navigate to="/dashboard/sign-in" state={{ from: location }} />;
  }

  if (token && location.pathname === "/dashboard/sign-in") {
    return <Navigate to="/dashboard/certificate/template/list" state={{ from: location }} />;
  }

  return <Outlet />;
};

export default PrivateRoute;
